import { http } from '@/utils/http'

const state = {
  productList: []
}

const actions = {
  fetchProductListOrWebchat ({ commit }, type) {
    return new Promise((resolve, reject) => {
      http('/api/member/product/list', type, 'get').then(res => {
        if (res.code === '0000') {
          commit('updateProductList', res.data)
          resolve()
        } else {
          reject(res.msg)
        }
      }, err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  updateProductList (state, b) {
    state.productList = b
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
